<template>
<div id="app">
	<main>
  <div id="c-datab">
  <div class="l-column-wrap_db box_db">
    <div v-if="category_id" aria-label="breadcrumb" class="breadclumbs_db bnav-t_db">
      <ul class="breadcrumb_d">
        <div v-for="crumb in breadcrumbs" :key="crumb.name">
        <li v-if="!crumb.active" class=""><router-link :to="crumb.path">{{crumb.name}}</router-link>&nbsp;/&nbsp;</li>
        <li v-else class="breadcrumb-item active" aria-current="page">{{crumb.name}}</li>
        </div>
      </ul>
    </div>
    <div class="l-column-main_db">
      <router-view name="mainview" :categorySet="sortCategories"/>
    </div>
		<!-- sidebar-ac -->
    <div class="l-column-nav_db">
      <router-view name="side" :categorySet="sortCategories"/>
    </div>
	</div>
	</div>
	</main>
</div>
</template>

<script>
  import { computed, getCurrentInstance } from 'vue'
  import { useHead } from '@vueuse/head'

  export default {
    name: 'App',
    components: {
    },
    setup() {
      const instance = getCurrentInstance()
      const vm = instance && instance.proxy
      const title = computed(() => (vm && vm.title) ? vm.title : '')
      const description = computed(() => (vm && vm.description) ? vm.description : '')
      const keywords = computed(() => (vm && vm.keywords) ? vm.keywords : '')

      useHead({
        title,
        meta: computed(() => [
          { name: 'description', content: description.value },
          { name: 'keywords', content: keywords.value }
        ])
      })

      return {}
    },
    provide: function () {
      return {
        setBreadcrumbContext: this.setBreadcrumbContext,
        setPageMeta: this.setPageMeta
      }
    },
    data: function () {
      return {
        siteName: "甲陽建機リース",
        defaultTitle: "商品カタログ",
        title: "商品カタログ | 甲陽建機リース",
        description: "建設機械レンタルの甲陽建機リース株式会社です。当社で取り扱いのある商品のカタログを掲載しています。各種性能表が掲載されており、カタログPDFファイルをダウンロードすることもできます。機種一覧からカテゴリごとに分類された商品を選択することもできますし、フリーワード検索にも対応しております。",
        keywords: "建設機械,土木機械,掘削機,バックホー,油圧ショベル,レンタカー,道路機械,解体,林業,アタッチメント,高所作業車,整地,運搬機械",
        categories: [],
        breadcrumbs: [{
          name: 'HOME',
          path: '',
          active: true
        }],
        category_id: null,
        active_page_title: null,
        lastPageViewKey: ''
      }
    },
    mounted : function () {
      this.sendPageView()
      //categories
      var url = process.env.VUE_APP_URL + '/categories/search'
      var myToken = process.env.VUE_APP_TOKEN
      var myComId = process.env.VUE_APP_COMPANY_ID
      var params = {'limit': 1000, 'company_id': myComId}
      var myHeaders = {'Content-Type': 'application/json', 'Authorization': `Token ${myToken}` }
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers : myHeaders,
        body: JSON.stringify(params)
      })
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.categories = data
      })
      .catch(e => console.error(e))
    },
    created: function () {
    },
    methods : {
      setBreadcrumbContext: function (categoryId, activePageTitle = '') {
        this.category_id = categoryId
        this.active_page_title = activePageTitle
      },
      formatPageTitle: function (title) {
        var pageTitle = title || this.defaultTitle
        if (pageTitle === this.siteName) return pageTitle
        return pageTitle + ' | ' + this.siteName
      },
      setPageMeta: function (title, description, keywords) {
        if (title !== undefined) this.title = this.formatPageTitle(title)
        if (description !== undefined) this.description = description
        if (keywords !== undefined) this.keywords = keywords
        this.sendPageView()
      },
      sendPageView: function () {
        if (!this.$gtag || !this.$gtag.pageview || typeof window === 'undefined') {
          return
        }
        var pagePath = this.$route ? this.$route.fullPath : window.location.pathname
        var pageViewKey = pagePath + '|' + this.title
        if (pageViewKey === this.lastPageViewKey) {
          return
        }
        this.lastPageViewKey = pageViewKey
        this.$gtag.pageview({
          page_title: this.title,
          page_path: pagePath,
          page_location: window.location.href
        })
      },
      setBreadcrumbs: function (id) {
        for(var i=0; i<this.sortCategories.length; i++){
          if(this.sortCategories[i].id == id){
            this.breadcrumbs = [
              {
                name: 'HOME',
                path: '/',
                active: false
              },
              {
                name: this.sortCategories[i].name,
                path: '/speclist/' + this.sortCategories[i].name,
                active: true
              }
            ]
            break
          }
          for(var j=0; j<this.sortCategories[i].child.length; j++){
            if(this.sortCategories[i].child[j].id == id){
              this.breadcrumbs = [
                {
                  name: 'HOME',
                  path: '/',
                  active: false
                },
                {
                  name: this.sortCategories[i].name,
                  path: '/speclist/' + this.sortCategories[i].name,
                  active: false
                },
                {
                  name: this.sortCategories[i].child[j].name,
                  path: '',
                  active: true
                },
              ]
              break
            }
            for(var k=0; k<this.sortCategories[i].child[j].child.length; k++){
              if(this.sortCategories[i].child[j].child[k].id == id){
                this.breadcrumbs = [
                  {
                    name: 'HOME',
                    path: '/',
                    active: false
                  },
                  {
                    name: this.sortCategories[i].name,
                    path: '/speclist/' + this.sortCategories[i].name,
                    active: false
                  },
                  {
                    name: this.sortCategories[i].child[j].child[k].name,
                    path: '/list/' + this.sortCategories[i].child[j].child[k].id,
                    active: false
                  },
                  {
                    name: this.active_page_title,
                    path: '',
                    active: true
                  },
                ]
                break
              }   
            }
          }
        }
      }
    },
    computed: {
      sortCategories: function() {
        var cat = this.categories
        var cat2h = {}; // idをキーにしたhash
        var mother_key = 0;
        for(var i=0;i<cat.length;i++){
          cat[i].show = false;
          cat[i].child = [];
          cat2h[cat[i].id] = cat[i];
        }
        for(i=0;i<cat.length;i++){
          mother_key = cat[i].category_id;
          if(mother_key){
            cat2h[mother_key].child.push(cat[i]);
          }
        }
        var catout = []
        for(var key in cat2h){
          if(!cat2h[key].category_id){
            catout.push(cat2h[key]);
          }
        }
        return catout;
      }
    },
    watch: {
      'category_id': function () {
        this.setBreadcrumbs(this.category_id)
      },
      'active_page_title': function () {
        this.setBreadcrumbs(this.category_id)
      },
      'categories': function () {
        if (this.category_id) {
          this.setBreadcrumbs(this.category_id)
        }
      }
    }
  }
</script>
